import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseTableService } from '../../services/firebase-table.service';
import { SharedTableComponent } from '@tamilarasitech/shared-ui-components';

@Component({
  selector: 'app-agencymembers',
  standalone: true,
  imports: [CommonModule, SharedTableComponent],
  templateUrl: './agencymembers.component.html',
  styleUrls: ['./agencymembers.scss']
})
export class AgencyMembersComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private firebaseService = inject(FirebaseTableService);
  private router = inject(Router);

  agencyData: any = null;
  memberStats = { total: 0, active: 0, inactive: 0, suspended: 0 };
  loading = true;
  error: string | null = null;
  agencyId: string = '';

  ngOnInit() {
    this.agencyId = this.route.snapshot.params['id'];
    if (this.agencyId) {
      this.loadAgencyData();
      this.loadMemberStats(); // Load actual stats instead of hardcoded
    } else {
      this.error = 'No agency ID provided';
      this.loading = false;
    }
  }

  goBack(): void {
    this.router.navigate(['/agencies']);
  }

  async loadAgencyData() {
    this.loading = true;
    this.error = null;
    try {
      const agencyPath = `data/digitvcards/agencies`;
      // Use the service method for proper injection context
      const agencyDoc = await this.firebaseService.getDoc(agencyPath, this.agencyId);
      if (agencyDoc) {
        this.agencyData = agencyDoc;
      } else {
        this.error = 'Agency not found';
      }
    } catch (error) {
      this.error = 'Failed to load agency details';
    } finally {
      this.loading = false;
    }
  }
  async loadMemberStats() {
  try {
    // Query memberships where 'agencyId' matches the current agency
    const queryConfig = {
      field: 'agencyId',
      op: '==',
      param: this.agencyId
    };

    // Fetch up to 500 members (adjust the limit as needed)
    const memberships = await this.firebaseService.getPaginatedData(
      'data/digitvcards/memberships',
      500,
      undefined,
      queryConfig
    );

    // Build stats based on status field
    this.memberStats = {
      total: memberships.data.length,
      active: memberships.data.filter((m: any) => m.status === 'active').length,
      inactive: memberships.data.filter((m: any) => m.status === 'inactive').length,
      suspended: memberships.data.filter((m: any) => m.status === 'suspended').length
    };
  } catch (error) {
    console.error('Error loading member stats:', error);
    this.memberStats = { total: 0, active: 0, inactive: 0, suspended: 0 };
  }
}

  getPlanLabel(plan: string): string {
    const plans: { [key: string]: string } = {
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Enterprise'
    };
    return plans[plan] || plan;
  }
}